import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import AuthForm from '@/components/auth/AuthForm';
import ProtectedRoute from '@/components/auth/ProtectedRoute';
import Header from '@/components/Header';
import MinimalFooter from '@/components/MinimalFooter';
import { Brain } from 'lucide-react';

export default function SignIn() {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      // Redirect to the page they tried to visit or home
      const from = (location.state as any)?.from?.pathname || '/';
      navigate(from, { replace: true });
    }
  }, [user, location, navigate]);

  return (
    <ProtectedRoute requireAuth={false}>
      <div className="min-h-screen bg-background flex flex-col">
        <Header onStartTour={() => {}} />
        
        <main className="flex-1 relative">
          {/* Background image with gradient overlay */}
          <div 
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: 'url("/images/auth-bg.jpg")',
              opacity: 0.1
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-background/80 to-background/40" />
          
          {/* Content */}
          <div className="relative container mx-auto px-4 py-12">
            <div className="max-w-md mx-auto">
              <div className="text-center mb-8">
                <div className="flex justify-center mb-4">
                  <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center">
                    <Brain className="h-6 w-6 text-primary" />
                  </div>
                </div>
                <h1 className="text-3xl font-bold tracking-tight mb-2">Welcome Back</h1>
                <p className="text-muted-foreground">
                  Sign in to continue your journey with BinauralFlow
                </p>
              </div>
              <AuthForm type="signin" />
            </div>
          </div>
        </main>
        
        <MinimalFooter />
      </div>
    </ProtectedRoute>
  );
} 